/**
 * Download Portal - File Availability Checker
 * Fetches product file data from API and hides products without files.
 * This runs asynchronously and overrides the no-op hideProductsWithoutFiles.
 */
(async function () {
    const downloadPortalDebug = (() => {
        try {
            const params = new URLSearchParams(window.location.search);
            return params.has('downloadPortalDebug') || window.localStorage.getItem('downloadPortalDebug') === '1';
        } catch (error) {
            return false;
        }
    })();

    async function getProductData() {
        const response = await fetch(
            'https://ocularsounds-middleware-eu-h8fkdagwccafcsax.westeurope-01.azurewebsites.net/api/data/entitylist',
            {
                headers: {
                    Authorization: 'Bearer eFc5NWMkOVF0U01mUGJzbSYwZGFzT3kmNVQ=',
                },
            }
        );
        return await response.json();
    }

    function getProductIdsFromAttribute(dataAttrValue) {
        if (/^\d+$/.test(dataAttrValue)) return [dataAttrValue];
        try {
            const parsed = JSON.parse(dataAttrValue);
            if (parsed && Array.isArray(parsed.productData)) {
                return parsed.productData.map((product) => String(product.productId));
            }
        } catch (error) { }
        return [];
    }

    // Show loading, hide grid
    var loadingDiv = document.getElementById('assets-loading');
    var listContainer = document.getElementById('listContainer');
    if (loadingDiv) loadingDiv.style.display = 'flex';
    if (listContainer) listContainer.style.display = 'none';

    const productFileList = await getProductData();
    const productIdsWithFiles = new Set((productFileList || []).map((item) => String(item.productId)));

    if (downloadPortalDebug) {
        console.groupCollapsed('[Download Portal] File availability data');
        console.log('Total file records from middleware:', (productFileList || []).length);
        console.log('Product IDs with files:', Array.from(productIdsWithFiles));
        console.groupEnd();
    }

    function hideProductsWithoutFiles() {
        document.querySelectorAll('[data-product-id]').forEach((productElement) => {
            const dataAttrValue = productElement.getAttribute('data-file-product-id') || productElement.getAttribute('data-product-id');
            const variantId = productElement.getAttribute('data-variant-id');

            let productIds = getProductIdsFromAttribute(dataAttrValue);

            if (variantId) {
                productIds.push(String(variantId));
            }

            const hasFile = productIds.some((id) => productIdsWithFiles.has(id));
            const isProductCard = productElement.classList.contains('list-product');

            if (!hasFile) {
                productElement.style.display = 'none';
            } else {
                const matchesFilters = productElement.dataset.matchesFilters;
                if (matchesFilters === 'false') {
                    productElement.style.display = 'none';
                } else if (matchesFilters === 'true' || matchesFilters === undefined) {
                    productElement.style.display = '';
                }
            }

            if (downloadPortalDebug && isProductCard) {
                console.debug('[Download Portal] File check result', {
                    title: productElement.dataset.title || '',
                    productIds,
                    hasFile,
                    matchesFilters: productElement.dataset.matchesFilters,
                    display: productElement.style.display || '',
                    productPayload: productElement.getAttribute('data-product-id'),
                    fileCheckPayload: productElement.getAttribute('data-file-product-id')
                });
            }
        });
    }

    // Override the no-op with the real implementation
    window.hideProductsWithoutFiles = hideProductsWithoutFiles;

    // Initial hide
    hideProductsWithoutFiles();

    // Hide loading, show grid
    if (loadingDiv) loadingDiv.style.display = 'none';
    if (listContainer) listContainer.style.display = '';
})();
